import { stringToNumber } from 'util/stringToNumber';
import { PropsWithChildren } from 'react';
import styled from 'styled-components';

export interface BasePlaceholderProps extends PropsWithChildren {
    participantId: string;
    ref?: React.RefObject<any>;
}

export const PlaceholderWrapper = styled.div`
    background: ${(props) => props.theme.root.colors.basicColors['8%']};
    display: flex;
    width: 100%;
    height: 100%;
    container-type: size;
`;

export const BasePlaceholder = styled.div<BasePlaceholderProps>`
    position: absolute;
    border-radius: 50%;
    left: 50%;
    top: 50%;
    aspect-ratio: 1 / 1;
    transform: translate(-50%, -50%);
    text-align: center;
    color: ${(props) => props.theme.root.colors.basicColors.white['100%']};
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ participantId, theme }) => {
        return theme.getAvatarColorsById(stringToNumber(participantId)).background;
    }};
`;

/**
 * Показывает спиннер пока видео загружается
 */
export const VideoLoadingOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;

    animation: fadeInOverlay 0.2s ease-in;

    @keyframes fadeInOverlay {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    &::before {
        content: '';
        width: 24px;
        height: 24px;
        border: 3px solid rgba(255, 255, 255, 0.2);
        border-top-color: #fff;
        border-radius: 50%;
        animation: spin 0.8s linear infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;

export const AvatarOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
`;
